// UserOrganizationService.ts
import Organization from "../../interfaces/identity/Organization"; // Import Organization interface

// Function to fetch a user's Organization by their user id
export async function getOrganizationByUserId(authToken: string): Promise<Organization | null> {
  
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/users/organization`
  
  try {
    const response = await fetch(apiUrl, {
      headers: { 
        'Authorization': `Bearer ${authToken}`
      }
    });

    if (!response.ok) {
      // Handle non-OK responses, e.g., 404 for not found
      return null;
    }

    const organizationData = await response.json();

    // Map the organization data to organization interface
    const organization: Organization = {
      name: organizationData.name,
      abbreviation: organizationData.abbreviation,
      atRiskWindowDays: organizationData.atRiskWindowDays, 
      defaultPtoDays: organizationData.defaultPtoDays
    };

    return organization;
  } catch (error) {
    // Handle network errors or other exceptions
    console.error('Error fetching task:', error);
    return null;
  }
}

export async function forgotPassword(email: string): Promise<boolean> {
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/Authentication/forgot-password`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      // If response is not OK, throw error with status and message
      const errorData = await response.json().catch(() => ({}));
      const error = new Error(errorData.message || "Failed to send reset email");
      (error as any).status = response.status;
      (error as any).response = { data: errorData };
      throw error;
    }

    return true;
  } catch (err) {
    console.error("Error sending reset email:", err);
    throw err; // Re-throw to let component handle it
  }
}

